import { render, staticRenderFns } from "./RecomendationSection.vue?vue&type=template&id=ed42cee4&"
import script from "./RecomendationSection.vue?vue&type=script&lang=js&"
export * from "./RecomendationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports